import { render, staticRenderFns } from "./ChatFileContextMenu.vue?vue&type=template&id=1852ee15"
import script from "./ChatFileContextMenu.vue?vue&type=script&lang=js"
export * from "./ChatFileContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ChatFileContextMenu.vue?vue&type=style&index=0&id=1852ee15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports